import React from 'react';
import PropTypes from 'prop-types';
import Markdown from 'react-markdown';
import { MESSAGE_TYPE_VALUES, MESSAGE_TYPES } from '../constants';
import { TrialCardMsg } from './TrialCardMsg/TrialCardMsg';
import { TrialOverviewMsg } from './TrialOverviewMsg/TrialOverviewMsg';
import { SocOverviewMsg } from './SocOverviewMsg/SocOverviewMsg';
import { TreatmentCardMsg } from './TreatmentCardMsg/TreatmentCardMsg';
import { ClinicalTrialAnalyticalAnswerMsg } from './ClinicalTrialAnalyticalAnswerMsg/ClinicalTrialAnalyticalAnswerMsg';
import { MARKDOWN_COMPONENTS } from './MarkdownComponents';

const AssistantMessage = ({ message }) => {
  switch (message.type) {
    case MESSAGE_TYPES.PLAIN_TEXT:
    case MESSAGE_TYPES.MARKDOWN: {
      return (
        <Markdown
          components={MARKDOWN_COMPONENTS}
        >
          {message.content}
        </Markdown>
      );
    }
    case MESSAGE_TYPES.ERROR:
      return <p>{message.content}</p>;
    case MESSAGE_TYPES.TRIAL_CARD:
      return <TrialCardMsg content={message.content} />;
    case MESSAGE_TYPES.TREATMENT_CARD:
      return <TreatmentCardMsg content={message.content} />;
    case MESSAGE_TYPES.SOC_OVERVIEW:
      return <SocOverviewMsg content={message.content} />;
    case MESSAGE_TYPES.TRIAL_OVERVIEW:
      return <TrialOverviewMsg content={message.content} />;
    case MESSAGE_TYPES.CLINICAL_TRIAL_ANALYTICAL_ANSWER:
      return <ClinicalTrialAnalyticalAnswerMsg content={message.content} />;
    case MESSAGE_TYPES.REACT_NODE:
      return message.content;
    default:
      return null;
  }
};

AssistantMessage.propTypes = {
  message: PropTypes.shape({
    type: PropTypes.oneOf(MESSAGE_TYPE_VALUES).isRequired,
    content: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.node,
    ]).isRequired,
  }).isRequired,
};

export const AssistantMessages = ({ messages }) => {
  if (!Array.isArray(messages) || messages.length === 0) {
    return null;
  }

  return (
    <div>
      {messages.map((m, idx) => (
        <AssistantMessage key={idx} message={m} />
      ))}
    </div>
  );
};

AssistantMessages.propTypes = {
  messages: PropTypes.arrayOf(AssistantMessage.propTypes.message),
};
